import { FormikProps } from 'formik';
import { get, isArray } from 'lodash';

type FormikErrors = Record<string, string>;

export interface FormikValues {
  errors?: FormikErrors;
  status?: {
    errors?: FormikErrors;
  };
  touched?: Record<string, boolean>;
}

export const useValidationText = (
  formik: FormikProps<FormikValues>,
  path: string,
) => {
  const errors = get(formik.errors, path);

  const touched =
    get(formik.touched, path) === true ||
    Boolean(formik.values[path as keyof typeof formik.values]);

  if (touched && typeof errors === 'string') return errors;

  const statusErrors = get(formik.status?.errors, path);
  if (statusErrors && isArray(statusErrors) && statusErrors.length) {
    return statusErrors[0];
  }
};
